import ProductClassAttributes from './ProductClassAttributes';
export default ProductClassAttributes;
